import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { isArray, isFunction, noop, unique } from '@dateam/ark';
var LogLevel = {
  'log': 0,
  'debug': 0,
  'info': 1,
  'warn': 2,
  'error': 3
};
var getDefaultLogFn = function getDefaultLogFn(logEntry) {
  var level = logEntry.level;
  switch (level) {
    case LogLevel.debug:
      return console.log;
    // eslint-disable-line no-console
    case LogLevel.info:
      return console.info;
    // eslint-disable-line no-console
    case LogLevel.warn:
      return console.warn;
    // eslint-disable-line no-console
    case LogLevel.error:
      return console.error;
    // eslint-disable-line no-console
    default:
      break;
  }
  return noop;
};
var log = function log(logEntry, options) {
  var level = logEntry.level;
  var currentLevel = options.currentLevel,
    handlers = options.handlers;
  if (currentLevel > level) return;
  if (handlers.length > 0) {
    handlers.forEach(function (handler) {
      return handler.callback(logEntry);
    });
  } else {
    var args = logEntry.args;
    var consoleFn = getDefaultLogFn(logEntry);
    if (!isFunction(consoleFn)) return;
    consoleFn.apply(void 0, _toConsumableArray(args));
  }
};
var containsLevel = function containsLevel(level) {
  return function (_ref) {
    var levels = _ref.levels;
    return levels.length === 0 || levels.indexOf(level) >= 0;
  };
};
var Logger = /*#__PURE__*/function () {
  function Logger() {
    _classCallCheck(this, Logger);
    this._logLevels = unique(Object.values(LogLevel));
    this._currentLevel = LogLevel.debug;
    this._handlers = [];
  }
  return _createClass(Logger, [{
    key: "debug",
    value: function debug() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      log({
        level: LogLevel.debug,
        args: args
      }, {
        currentLevel: this._currentLevel,
        handlers: this._handlers.filter(containsLevel(LogLevel.debug))
      });
    }

    // log is merely an alias for debug
  }, {
    key: "log",
    value: function log() {
      this.debug.apply(this, arguments);
    }
  }, {
    key: "info",
    value: function info() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      log({
        level: LogLevel.info,
        args: args
      }, {
        currentLevel: this._currentLevel,
        handlers: this._handlers.filter(containsLevel(LogLevel.info))
      });
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      log({
        level: LogLevel.warn,
        args: args
      }, {
        currentLevel: this._currentLevel,
        handlers: this._handlers.filter(containsLevel(LogLevel.warn))
      });
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      log({
        level: LogLevel.error,
        args: args
      }, {
        currentLevel: this._currentLevel,
        handlers: this._handlers.filter(containsLevel(LogLevel.error))
      });
    }
  }, {
    key: "setLevel",
    value: function setLevel(level) {
      if (this._logLevels.indexOf(level) < 0) throw new Error('Unknown log level.');
      this._currentLevel = level;
    }
  }, {
    key: "setHandler",
    value: function setHandler(levels, handler) {
      if (!isArray(levels)) throw new Error('handler\'s levels are not valid.');
      if (!isFunction(handler)) throw new Error('handler is not valid.');
      this._handlers.push({
        levels: levels,
        callback: handler
      });
    }
  }]);
}();
Logger.LOG = LogLevel.log;
Logger.DEBUG = LogLevel.debug;
Logger.INFO = LogLevel.info;
Logger.WARN = LogLevel.warn;
Logger.ERROR = LogLevel.error;
export default Logger;